document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('section-mailer-feature')) {
    class sectionMailerFeature extends HTMLElement {
      constructor() {
        super();

        this.contentCard = this.querySelector('.content-card');

        // if window enable swiper on resize
        window.addEventListener('resize', () => {
          this.onResize();
        });

        this.onResize();
      }

      onResize() {
        if (window.innerWidth < 992) {
          this.enableSwiper();
        } else {
          if (this.slider) this.slider.destroy(true, true);
        }
      }

      enableSwiper() {
        this.slider = new Swiper(this.contentCard, {
          slidesPerView: 1,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }
    }

    customElements.define('section-mailer-feature', sectionMailerFeature);
  }
});
